// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const HeartInactive: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 13"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="14"
            height="13"
            fill="currentColor"
        >
            <path
                d="M903.635547,625.468828 C902.998437,624.89625 902.180859,624.600391 901.355078,624.625 C900.329962,624.625 899.295273,625.046094 898.538672,625.827578 L898,626.381836 L897.461328,625.827578 C896.703906,625.046094 895.670313,624.625 894.644922,624.625 C893.81914,624.625 893.002383,624.896523 892.340937,625.468828 C890.641797,626.939648 890.556758,629.562187 892.088555,631.145391 L897.371367,636.605938 C897.546094,636.784766 897.770313,636.875 897.997265,636.875 C898.225094,636.875 898.453633,636.785668 898.626445,636.606922 L903.906524,631.146376 C905.442969,629.560547 905.358202,626.938281 903.635547,625.468828 Z M902.965625,630.233203 L898,635.36836 L893.032734,630.233203 C892.151172,629.322656 891.942265,627.526172 893.200078,626.461133 C894.291094,625.516679 895.786523,625.982617 896.519609,626.739219 L898.00082,628.268281 L899.481758,626.739219 C900.20418,625.993554 901.703711,625.511758 902.801289,626.461133 C904.045703,627.539844 903.865234,629.303516 902.965625,630.233203 Z"
                opacity=".66"
                transform="translate(-891 -624)"
            />
        </svg>
    );
};

export default React.memo(HeartInactive);
